export const buildGetStripeCustomerApiConfig = () => ({
    url: '/api/billing/stripe-customer',
    method: 'GET',
});

export const buildCreateStripeCustomerApiConfig = data => ({
    url: '/api/billing/stripe-customer',
    method: 'POST',
    data,
});

export const buildUpdateStripeCustomerApiConfig = ({ stripeCustomerId, data }) => ({
    url: `/api/billing/stripe-customer/${stripeCustomerId}`,
    method: 'PATCH',
    data,
});
